import React, { useState, useEffect } from "react";
import { IconSquareRoundedPlus } from "@tabler/icons-react";
import { IconRefresh } from "@tabler/icons-react";
import { IconSquareRoundedX } from "@tabler/icons-react";

const EditCarouselImages = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 10000);
    return () => clearInterval(interval);
  }, [currentIndex]);
  return (
    <div className="carousel-container">
      <div
        className="image-wrapper"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images && images.length > 0 ? (
          images.map((image, index) => {
            const lastItem = image.imageName.split("/").pop();
            return (
              <>
                <div className="edit-image-options">
                  <div className="addImage">
                    <IconSquareRoundedPlus stroke={2} />
                  </div>
                  <div className="updateImage">
                    <IconRefresh stroke={2} />
                  </div>
                  <div className="DeleteImage">
                    <IconSquareRoundedX stroke={2} />
                  </div>
                </div>
                <img
                  key={index}
                  className={"responsive-image"}
                  src={`http://localhost:8000/images/${lastItem}`}
                  alt={`House ${index + 1}`}
                />
              </>
            );
          })
        ) : (
          <p>No images available</p>
        )}
      </div>
      {images.length > 1 ? (
        <>
          <div className="arrow left" onClick={prevSlide}>
            &#10094;
          </div>
          <div className="arrow right" onClick={nextSlide}>
            &#10095;
          </div>
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default EditCarouselImages;
